import { useMemo } from 'react';
import { useCompany } from '../hooks/company';

import dayjs from 'dayjs';
import { UpdatePasswordModal } from '../pages/UserInfo';

export default function PasswordUpdateCheck() {
  const { currentUser } = useCompany();

  const shouldUpdatePassword = useMemo(() => {
    if (currentUser.id === 10000) {
      return false;
    }
    if (!currentUser.userConfig?.passwordLastUpdatedAt) {
      return true;
    }
    const lastUpdatedAt = dayjs(currentUser.userConfig?.passwordLastUpdatedAt);
    return lastUpdatedAt.isBefore(dayjs().subtract(3, 'month'));
  }, [currentUser.userConfig?.passwordLastUpdatedAt]);

  if (!shouldUpdatePassword) {
    return null;
  }

  return (
    <>
      <UpdatePasswordModal
        open={shouldUpdatePassword}
        tips="您的密码已超过一个月未更新，请及时更新密码"
      />
    </>
  );
}
